import { Box } from "@mui/material"

const BottomRight = (props) => {
    return (
        <Box
            sx={{
                position: "absolute",
                bottom:0,
                right:0,
                display:"flex"
            }}
        >
            {props.children}
        </Box>
    )
}

export default BottomRight;